import { useContext } from 'react';
import { toCurrency, toFormattedDate } from "../../../utilities/FormatHelpers";
import { AccountContext } from "../AccountContext";

export default function DueAmounts() {
    const { previousBillingPeriod } = useContext(AccountContext);

    return (
        <>
            <div className="ui card">
                <div className="custom-card-header">
                    Due Amounts
                </div>
                <div className="content">
                    {previousBillingPeriod &&
                        <div>
                            <p>Payment Requested: {toCurrency(previousBillingPeriod.paymentRequested?.amount?.value)}</p>
                            {previousBillingPeriod.updatedPaymentRequested &&
                                <p>Updated Payment Requested: {toCurrency(previousBillingPeriod.updatedPaymentRequested?.amount?.value)}</p>
                            }
                            <p>Payment Due
                                Date: {toFormattedDate(previousBillingPeriod.paymentDueDate)}</p>
                            <p>Minimum Due: {toCurrency(previousBillingPeriod.paymentRequested?.minimumDue?.total?.value)}</p>
                            <p>Instalments
                                Due: {toCurrency(previousBillingPeriod.paymentRequested?.instalmentPlans?.totalInstalmentDue?.value)}</p>
                        </div>}
                    {!previousBillingPeriod && <p>Nothing due yet</p>}
                </div>
            </div>
        </>);
}